import { Plugin } from "@src/plugins/ckeditor5-core/src/index";

export default class SpecialCharactersGreek extends Plugin {
	static get pluginName() {
		return "SpecialCharactersGreek";
	}
	init() {
		const editor = this.editor;
		const t = editor.t;

		editor.plugins.get("SpecialCharacters").addItems("Greek", [
			{ title: t("Alpha"), character: "Α" },
			{ title: t("alpha"), character: "α" },
			{ title: t("Beta"), character: "Β" },
			{ title: t("beta"), character: "β" },
			{ title: t("Gamma"), character: "Γ" },
			{ title: t("gamma"), character: "γ" },
			{ title: t("Delta"), character: "Δ" },
			{ title: t("delta"), character: "δ" },
			{ title: t("Epsilon"), character: "Ε" },
			{ title: t("epsilon"), character: "ε" },
			{ title: t("Zeta"), character: "Ζ" },
			{ title: t("zeta"), character: "ζ" },
			{ title: t("Eta"), character: "Η" },
			{ title: t("eta"), character: "η" },
			{ title: t("Theta"), character: "Θ" },
			{ title: t("theta"), character: "θ" },
			{ title: t("Iota"), character: "Ι" },
			{ title: t("iota"), character: "ι" },
			{ title: t("Kappa"), character: "Κ" },
			{ title: t("kappa"), character: "κ" },
			{ title: t("Lambda"), character: "Λ" },
			{ title: t("lambda"), character: "λ" },
			{ title: t("Mu"), character: "Μ" },
			{ title: t("mu"), character: "μ" },
			{ title: t("Nu"), character: "Ν" },
			{ title: t("nu"), character: "ν" },
			{ title: t("Xi"), character: "Ξ" },
			{ title: t("xi"), character: "ξ" },
			{ title: t("Omicron"), character: "Ο" },
			{ title: t("omicron"), character: "ο" },
			{ title: t("Pi"), character: "Π" },
			{ title: t("pi"), character: "π" },
			{ title: t("Rho"), character: "Ρ" },
			{ title: t("rho"), character: "ρ" },
			{ title: t("Sigma"), character: "Σ" },
			{ title: t("sigma"), character: "σ" },
			{ title: t("Tau"), character: "Τ" },
			{ title: t("tau"), character: "τ" },
			{ title: t("Upsilon"), character: "Υ" },
			{ title: t("upsilon"), character: "υ" },
			{ title: t("Phi"), character: "Φ" },
			{ title: t("phi"), character: "φ" },
			{ title: t("Chi"), character: "Χ" },
			{ title: t("chi"), character: "χ" },
			{ title: t("Psi"), character: "Ψ" },
			{ title: t("psi"), character: "ψ" },
			{ title: t("Omega"), character: "Ω" },
			{ title: t("omega"), character: "ω" },
		]);
	}
}
